"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
// @ts-nocheck
const react_native_1 = require("react-native");
const react_native_paper_1 = require("react-native-paper");
const react_1 = __importStar(require("react"));
const Helper_1 = require("../Helper");
const Theme_1 = require("../Theme");
const ThemeContext_1 = require("../ThemeContext");
const react_native_fontawesome_1 = require("@fortawesome/react-native-fontawesome");
const DropDown = (0, react_1.forwardRef)((props, ref) => {
    const activeTheme = (0, react_native_paper_1.useTheme)();
    const NextepTheme = (0, ThemeContext_1.useTheme)();
    const STYLES = (0, Theme_1.useGlobalStyles)();
    const { disabled = false, error = false, multiSelect = false, value, setValue, activeColor, mode, label, showLabelOnDropDownOnly, placeholder, inputProps, list, dropDownContainerMaxHeight, dropDownContainerHeight, dropDownStyle, dropDownItemStyle, dropDownItemSelectedStyle, dropDownItemTextStyle, dropDownItemSelectedTextStyle, titleNumberOfLines = 1, height } = props;
    const [visible, setVisible] = (0, react_1.useState)(false);
    const [displayValue, setDisplayValue] = (0, react_1.useState)("");
    const [inputLayout, setInputLayout] = (0, react_1.useState)({
        height: 0,
        width: 0,
        x: 0,
        y: 0,
    });
    const onDismiss = () => {
        setVisible(false);
    };
    const showDropDown = () => {
        setVisible(true);
    };
    const onLayout = (event) => {
        setInputLayout(event.nativeEvent.layout);
    };
    (0, react_1.useEffect)(() => {
        if (multiSelect) {
            const _labels = list
                .filter((_) => {
                const values = value.split(",");
                return values.includes(_.value);
            })
                .map((_) => _.label)
                .join(", ");
            setDisplayValue(_labels);
        }
        else {
            const _label = list.find((_) => _.value === value)?.label;
            if (_label) {
                setDisplayValue(_label);
            }
            else
                setDisplayValue('');
        }
    }, [list, value]);
    const isActive = (0, react_1.useCallback)((currentValue) => {
        if (multiSelect) {
            const values = value.split(",");
            return values.includes(currentValue);
        }
        else {
            return value === currentValue;
        }
    }, [value]);
    const setActive = (currentValue) => {
        if (multiSelect) {
            const valueIndex = value.indexOf(currentValue);
            const values = value.split(",");
            if (valueIndex === -1) {
                setValue([...values, currentValue].join(","));
            }
            else {
                setValue([...values].filter((value) => value !== currentValue).join(","));
            }
        }
        else {
            setValue(currentValue);
        }
    };
    return ((0, jsx_runtime_1.jsx)(react_native_paper_1.Menu, { visible: visible, onDismiss: onDismiss, anchor: (0, jsx_runtime_1.jsx)(react_native_paper_1.TouchableRipple, { disabled: disabled, onPress: showDropDown, onLayout: onLayout, "aria-label": props["aria-label"] ?? label + ': ' + displayValue, children: (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { pointerEvents: "none" }, children: (0, jsx_runtime_1.jsx)(react_native_paper_1.TextInput, { accessible: false, disabled: disabled, error: error, readOnly: true, value: displayValue, mode: mode, label: showLabelOnDropDownOnly ? undefined : label, dense: true, placeholder: placeholder, right: (0, jsx_runtime_1.jsx)(react_native_paper_1.TextInput.Icon, { disabled: true, style: { marginBottom: Helper_1.Helper.isPlatformWeb ? (props.height !== undefined ? 0 : 8) : 4 }, icon: ({ color, size }) => ((0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: visible ? Theme_1.ICONS.Regular.ChevronUp : Theme_1.ICONS.Regular.ChevronDown, color: color, size: 16 })), theme: {
                            ...NextepTheme,
                            colors: { onSurfaceDisabled: disabled ? NextepTheme.TextDisabled : NextepTheme.Text }
                        } }), ...inputProps, style: [STYLES.input, { pointerEvents: "none", ...(props.height !== undefined ? { height: props.height } : {}) }] }) }) }), style: {
            width: inputLayout?.width,
            marginTop: inputLayout?.height,
            ...dropDownStyle,
        }, children: (0, jsx_runtime_1.jsx)(react_native_1.ScrollView, { bounces: false, style: {
                backgroundColor: NextepTheme.CardBackground,
                ...(dropDownContainerHeight
                    ? {
                        height: dropDownContainerHeight,
                    }
                    : {
                        maxHeight: dropDownContainerMaxHeight || 350,
                    }),
            }, children: list.map((_item, _index) => ((0, jsx_runtime_1.jsx)(react_1.Fragment, { children: (0, jsx_runtime_1.jsx)(react_native_paper_1.TouchableRipple, { disabled: _item.disabled, style: {
                        flexDirection: "row",
                        alignItems: "center",
                        backgroundColor: NextepTheme.CardBackground,
                    }, onPress: () => {
                        setActive(_item.value);
                        if (!multiSelect)
                            onDismiss();
                    }, children: (0, jsx_runtime_1.jsxs)(react_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(react_native_paper_1.List.Item, { titleNumberOfLines: titleNumberOfLines, titleStyle: {
                                    fontWeight: isActive(_item.value) ? "500" : "400",
                                    color: isActive(_item.value)
                                        ? activeColor || activeTheme.colors.primary
                                        : (_item.disabled ? NextepTheme.TextLight : NextepTheme.Text),
                                    ...(isActive(_item.value)
                                        ? dropDownItemSelectedTextStyle
                                        : dropDownItemTextStyle)
                                }, title: _item.custom || _item.label, style: {
                                    flex: 1,
                                    ...(isActive(_item.value) ? { backgroundColor: `${NextepTheme.Primary}22` } : {}),
                                    ...(isActive(_item.value)
                                        ? dropDownItemSelectedStyle
                                        : dropDownItemStyle),
                                } }), multiSelect && ((0, jsx_runtime_1.jsx)(react_native_1.View, { style: { justifyContent: 'center', marginRight: 14 }, children: (0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: isActive(_item.value) ? Theme_1.ICONS.Solid.SquareCheck : Theme_1.ICONS.Regular.Square, size: 18, color: activeColor || NextepTheme.Primary }) }))] }) }) }, _item.value))) }) }));
});
exports.default = DropDown;
